var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.941,
    height: 17,
    viewBox: "0 0 14.941 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete_1_",
    "data-name": "delete (1)",
    transform: "translate(-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13844",
    "data-name": "Path 13844",
    d: "M31.5,151h1.494v10.525a.5.5,0,0,0,.5.5h9.961a.5.5,0,0,0,.5-.5V151h1.494a.5.5,0,0,0,0-1H31.5a.5.5,0,0,0,0,1Zm4.482,9.031a.5.5,0,0,1-1,0v-8.035a.5.5,0,0,1,1,0Zm2.988,0a.5.5,0,0,1-1,0v-8.035a.5.5,0,0,1,1,0Zm2.988,0a.5.5,0,0,1-1,0v-8.035a.5.5,0,0,1,1,0Z",
    transform: "translate(0 -145.02)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13845",
    "data-name": "Path 13845",
    d: "M73.949,2.49a.5.5,0,0,0-.5-.5H69.965V.5a.5.5,0,0,0-.5-.5H65.482a.5.5,0,0,0-.5.5V1.992H61.5a.5.5,0,0,0-.5.5V3.984H73.949ZM65.98,1h2.988v1H65.98Z",
    transform: "translate(-29.004)",
    fill: "#777"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.359cb286aba110e75b6ff05d5b13cd91.svg";
export { ForwardRef as ReactComponent };